/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type LocationResponseDto = {
    id: string;
    address_line1: string;
    address_line2?: string | null;
    city: string;
    state: string;
    country: string;
    postal_code?: string | null;
    latitude?: number | null;
    longitude?: number | null;
    is_primary?: boolean | null;
    location_type?: LocationResponseDto.location_type | null;
    timezone?: string | null;
};
export namespace LocationResponseDto {
    export enum location_type {
        CURRENT = 'current',
        SESSION = 'session',
    }
}

